import AllRoutes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ProfileProvider } from "./context/ProfileContext";
import { ReadOnlyDatesProvider } from "./context/ReadOnlyDatesContext";
import { OrderBoardingProvider } from "./context/OrderBoardingContext";

const App = () => {
  return (
    <DndProvider backend={HTML5Backend}>
      <ProfileProvider>
        <ReadOnlyDatesProvider>
          <OrderBoardingProvider>
            <AllRoutes />
            <ToastContainer pauseOnHover={false} />
          </OrderBoardingProvider>
        </ReadOnlyDatesProvider>
      </ProfileProvider>
    </DndProvider>
  );
};

export default App;
